export enum AssignedTime {
    Morning = 'Morning',
    Afternoon = 'Afternoon',
}
